namespace Vit {
    export class DynamicUIFactory {
        public static create(uiInfo: SergenUIModelInfo, parentNode: HTMLElement) {
            if (!(parentNode instanceof HTMLElement)) {
                return;
            }

            switch (uiInfo.UIType) {
                case UIType.GridUI:
                    let columnInfo = [];

                    for (const col of uiInfo.Fields) {
                        if (col.Visible == Visibility.Visible) {
                            columnInfo.push(DynamicUIFactory.getColumn(<SergenGridFieldInfo>col));
                        }

                        if ((<SergenGridFieldInfo>col).Fields) {
                            for (const subCol of (<SergenGridFieldInfo>col).Fields) {
                                if (subCol.Visible == Visibility.Visible) {
                                    columnInfo.push(DynamicUIFactory.getColumn(<SergenGridFieldInfo>subCol));
                                }
                            }
                        }
                    }

                    Q.ScriptData.set("Columns.Vit.DynamicGrid", columnInfo);
                    const gridID = this.declareElements(uiInfo.UIType, parentNode);

                    if (!gridID) {
                        return false;
                    }

                    const $grid = $(`#${gridID}`);
                    new DynamicGridBase($grid).init();
                    Q.initFullHeightGridPage($grid);

                    break;
                case UIType.FormUI:
                    Q.ScriptData.set("Lookup.Vit.DynamicEntityLookupScript", new Q.Lookup({
                        "idField": "BicycleGuid",
                        "textField": "BicycleNumber",
                    }));

                    let formInfo: Array<IFormInfo> = [],
                        currentTab: string = "",
                        currentCat: string = "",
                        index = 0;

                    const clone = $.extend(true, [], uiInfo.Fields);
                    clone.sort((item1, item2) => item1.Order - item2.Order);

                    for (const field of clone) {
                        if (field.Visible != Visibility.Visible) {
                            continue;
                        }

                        let tempField = <SergenFormFieldInfo>field;

                        if (tempField.GridEditorType != null) {
                            let ColsName: Array<IColumnName> = [];
                            var GridColumns = tempField.GridEditorType.Fields;

                            GridColumns.forEach(function (value) {
                                var count = 1,
                                    c: IColumnName = {
                                        name: `Col${count.toString()}`,
                                        title: value.Name,
                                    };
                                ColsName.push(c);
                                ++count;
                            });

                            Q.ScriptData.set(`Columns.Vit.DetailGridEditor_${index.toString()}`, ColsName);
                            DynamicDetailGridEditorFactory.create(`DetailGridEditor_${index.toString()}`);
                        }

                        if (tempField.Tab) {
                            currentTab = tempField.Tab;
                        }

                        if (tempField.Category) {
                            currentCat = tempField.Category;
                        }

                        var editorPrms = <IEditorParams>{};

                        if (tempField.MaxLength) {
                            editorPrms.maxLength = parseInt(tempField.MaxLength);
                        }

                        if (tempField.Editor == FormEditorType.LookupEditor) {
                            editorPrms.lookupKey = "Vit.DynamicEntityLookupScript";
                        }

                        formInfo.push({
                            name: tempField.Name,
                            title: tempField.DisplayName,
                            required: tempField.Required,
                            width: tempField.Width,
                            insertable: tempField.InsertableAttrib,
                            updateable: tempField.UpdatableAttrib,
                            placeholder: tempField.Placeholder,
                            ignore: tempField.Ignore,
                            ignoreName: tempField.IgnoreName,
                            // editorType: "String",
                            editorType: (tempField.Editor != FormEditorType.GridEditor) ? FormEditorType[tempField.Editor] : `Vit.DynamicDetailGridEditor_${index.toString()}`,
                            alignment: (tempField.AlignRight) ? "right" : "center",
                            hideOnInsert: tempField.HideOnInsert,
                            hideOnUpdate: tempField.HideOnUpdate,
                            oneWay: tempField.OneWay,
                            category: currentCat,
                            tab: currentTab,
                            maxLength: tempField.MaxLength,
                            editorParams: editorPrms,
                            labelWidth: `${tempField.LabelWidth}px`,
                            formCssClass: (tempField.PropWidth) ? EnumHelper.GetPropWidth(tempField.PropWidth) : EnumHelper.GetPropWidth(PropWidth.FullWidth)
                        });

                        index++;
                    }

                    Q.ScriptData.set("Form.Vit.DynamicEntityDialog", formInfo);
                    const form = new Vit.DynamicEntityDialog(),
                        formID = this.declareElements(uiInfo.UIType, parentNode);

                    if (!formID) {
                        return false;
                    }

                    form.load({}, () => {
                        const container = document.querySelector(`#${formID}`);

                        if (!container) {
                            return;
                        }

                        container.classList.add("s-Dialog");
                        form.element.removeClass("hidden").addClass("dialog-content flex-layout").appendTo(container);
                    }, () => {
                    });

                    break;
            }
        }

        static declareElements(type: UIType, parentNode: HTMLElement): string | boolean {
            if ((!parentNode || !(parentNode instanceof HTMLElement)) || !document.body.contains(parentNode)) {
                return false;
            }

            switch (type) {
                case UIType.GridUI:
                    let content = document.createElement("section");
                    content.className = "content";
                    let gridContainer = document.createElement("div");
                    gridContainer.id = "GridDiv";
                    content.appendChild(gridContainer);
                    parentNode.appendChild(content);

                    return gridContainer.id;
                case UIType.FormUI:

                    return parentNode.id;
                default:

                    return false;
            }
        }

        private static getColumn(tempCol: SergenGridFieldInfo) {
            return {
                name: tempCol.Name,
                title: tempCol.DisplayName,
                editLink: tempCol.EditLink,
                visible: !tempCol.Hidden,
                width: tempCol.Width,
                sortable: tempCol.Sortable,
                resizable: tempCol.Resizable,
                allowHide: tempCol.AllowHide,
                quickFilter: tempCol.QuickFilter,
                notFilterable: tempCol.NotFilterable,
                ignore: tempCol.Ignore,
                ignoreName: tempCol.IgnoreName,
                formatterType: GridFormatter[tempCol.GridFormatter],
                alignment: (tempCol.AlignRight) ? "right" : "center",
            }
        }
    }

    @Serenity.Decorators.registerClass()
    export class DynamicGridBase extends Serenity.EntityGrid<any, any> {
        constructor(container: JQuery) {
            super(container);
        }

        protected getColumnsKey() {
            return "Vit.DynamicGrid";
        }

        protected getDialogType() {
            return null;
        }

        protected getIdProperty() {
            return null;
        }

        protected getLocalTextPrefix() {
            return null;
        }

        protected getService() {
            return null;
        }

        protected initialPopulate(): void {
        }
    }

    @Serenity.Decorators.registerClass()
    export class DynamicEntityDialog extends Serenity.EntityDialog<any, any> {
        protected getFormKey() {
            return "Vit.DynamicEntityDialog";
        }

        protected getIdProperty() {
            return null;
        }

        protected getLocalTextPrefix() {
            return null;
        }

        protected getNameProperty() {
            return null;
        }

        protected getService() {
            return null;
        }
    }

    //@Serenity.Decorators.registerClass()
    //export class DynamicDetailGridEditor extends GridEditorBase<any> {
    //    protected getColumnsKey() {
    //        return "Vit.DetailGridEditor";
    //    }

    //    protected getDialogType() {
    //        return null;
    //    }

    //    protected getIdProperty() {
    //        return null;
    //    }

    //    protected getLocalTextPrefix() {
    //        return null;
    //    }

    //    protected getService() {
    //        return null;
    //    }

    //    constructor(container: JQuery) {
    //        super(container);
    //    }

    //    protected initialPopulate(): void {
    //    }
    //}

    export class DynamicDetailGridEditorFactory {
        public static create(name: string) {
            var _super = Vit.GridEditorBase;

            var editorConstructor = function (container: JQuery) {
                var _this = _super.call(this, container, null) || this;

                return _this;
            };
            __extends(editorConstructor, _super);
            editorConstructor = __decorate([
                Serenity.Decorators.registerClass()
            ], editorConstructor);
            (<any>editorConstructor).prototype.getColumnsKey = function () {
                return `Vit.${name}`;
            };
            (<any>editorConstructor).prototype.getAddButtonCaption = function () {
                return "Add";
            };

            Vit[`Dynamic${name}`] = editorConstructor;
        }
    }

    export interface IFormInfo {
        name?: string;
        title?: string;
        required?: Boolean;
        width?: string;
        insertable: boolean,
        updateable: boolean,
        placeholder: string,
        ignore: boolean,
        ignoreName: boolean,
        editorType: string,
        alignment: string,
        hideOnInsert: boolean,
        hideOnUpdate: boolean,
        oneWay: boolean,
        category: string,
        tab: string,
        maxLength: string,
        editorParams?: IEditorParams,
        labelWidth: string,
        formCssClass: string
    }

    export interface IColumnName {
        name: string;
        title: string;
    }

    export interface IEditorParams {
        maxLength: number,
        lookupKey: string
    }
}